import { NgModule } from '@angular/core';
import { AngularMaterialModule } from '@shared/modules/angular-material.module';
import { IconService } from '@shared/services/icon.service';

@NgModule({
  imports: [AngularMaterialModule],
  providers: [IconService],
})
export class IconModule {
  constructor(private iconService: IconService) {}
}
